module.exports = __webpack_public_path__ + "static/img/jianbian.93a54717.png";